import { useState } from "react";
import { Hotel, ExternalLink } from "lucide-react";

const Hotels = () => {
  const providers = [
    {
      name: "Booking.com",
      url: "https://www.booking.com",
      description: "World's largest hotel booking site",
      iconBg: "bg-gradient-to-br from-blue-500 to-indigo-600",
    },
    {
      name: "Expedia",
      url: "https://www.expedia.com/Hotels",
      description: "Hotels, flights & packages",
      iconBg: "bg-gradient-to-br from-amber-500 to-yellow-600",
    },
    {
      name: "Hotels.com",
      url: "https://www.hotels.com",
      description: "Earn free nights with rewards",
      iconBg: "bg-gradient-to-br from-red-500 to-rose-600",
    },
    {
      name: "Airbnb",
      url: "https://www.airbnb.com",
      description: "Unique stays & experiences",
      iconBg: "bg-gradient-to-br from-rose-500 to-pink-600",
    },
    {
      name: "Trip.com",
      url: "https://www.trip.com/hotels",
      description: "Great coverage worldwide",
      iconBg: "bg-gradient-to-br from-cyan-500 to-sky-600",
    },
    {
      name: "Agoda",
      url: "https://www.agoda.com",
      description: "Best prices in Asia",
      iconBg: "bg-gradient-to-br from-purple-500 to-violet-600",
    },
    {
      name: "Hostelworld",
      url: "https://www.hostelworld.com",
      description: "Budget hostels worldwide",
      iconBg: "bg-gradient-to-br from-orange-500 to-amber-600",
    },
    {
      name: "Trivago",
      url: "https://www.trivago.com",
      description: "Compare hotel prices",
      iconBg: "bg-gradient-to-br from-teal-500 to-emerald-600",
    },
  ];

  return (
    <div className="page-container" data-testid="hotels-page">
      <div className="pb-28">
        {/* Hero Banner */}
        <div className="relative h-36 sm:h-44 overflow-hidden mb-6">
          <img src="https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1200&q=80" alt="" className="w-full h-full object-cover" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#080d19]/80 via-[#080d19]/20 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-4 pb-5">
            <h1 className="text-2xl font-bold font-heading text-white drop-shadow-lg">Hotels</h1>
            <p className="text-sm text-slate-300/80 mt-0.5 drop-shadow">Find your perfect stay</p>
          </div>
        </div>
        <div className="px-4">

        {/* Provider Cards */}
        <div>
          <h2 className="text-lg font-semibold text-white mb-4">Hotel Booking Sites</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {providers.map((provider, idx) => (
              <a
                key={idx}
                href={provider.url}
                target="_blank"
                rel="noopener noreferrer"
                className="glass-card p-4 hover:scale-[1.02] transition-all group border-2 border-transparent hover:border-white/20"
                data-testid={`provider-${provider.name.toLowerCase().replace(/\./g, "")}`}
              >
                <div className="flex items-center gap-4">
                  <div
                    className={`w-14 h-14 rounded-xl ${provider.iconBg} flex items-center justify-center shadow-lg`}
                  >
                    <Hotel className="w-7 h-7 text-white" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <h3 className="font-bold text-white text-lg">{provider.name}</h3>
                      <ExternalLink className="w-4 h-4 text-white/60 group-hover:text-white transition-colors" />
                    </div>
                    <p className="text-sm text-white/70">{provider.description}</p>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* Tips */}
        <div className="mt-6 glass-card p-4">
          <h3 className="font-semibold text-white mb-3">Hotel Booking Tips</h3>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li className="flex items-start gap-2">
              <span className="text-sky-400">•</span>
              Book directly with hotels for best price guarantees
            </li>
            <li className="flex items-start gap-2">
              <span className="text-sky-400">•</span>
              Check cancellation policies before booking
            </li>
            <li className="flex items-start gap-2">
              <span className="text-sky-400">•</span>
              Read recent reviews for accurate information
            </li>
            <li className="flex items-start gap-2">
              <span className="text-sky-400">•</span>
              Consider location vs. price trade-offs
            </li>
          </ul>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Hotels;
